enum EnvTypeEnum {
    TEST = "TEST",
    PREPROD = "PREPROD",
    PROD = "PROD"
}

export default EnvTypeEnum;
